import {
	requests
}from '../../../api/agent'

export default {
	getResponsibilityTypes      : (params) => requests.getWithParams('/ReResponsibilityTypes/ListAllPaged', params),
	getResponsibilityTypeByName : (params) => requests.getWithParams('/ReResponsibilityTypes/getByName', params),
	getList                     : (params) => requests.getWithParams('/ReResponsibilityTypes/getList', params),
	createResponsibilityType    : (params) => requests.post('/ReResponsibilityTypes/CreateResponsibilityType', params),
	deleteResponsibilityType    : (params) => requests.post('/ReResponsibilityTypes/DeleteResponsibilityType', params),
	updateResponsibilityType    : (params) => requests.post('/ReResponsibilityTypes/UpdateResponsibilityType', params),
	restoreResponsibilityType   : (params) => requests.post('/ReResponsibilityTypes/RestoreResponsibilityType', params)
}